import AppLogo from "./AppLogo";
import './appLogo.scss';

export default AppLogo;